/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Internal loading state tracked by the ImageLoader component.
 */
export const ImageLoadState = {
  IDLE: "idle",
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error"
} as const;

export type ImageLoadState =
  (typeof ImageLoadState)[keyof typeof ImageLoadState];
